import axios from '@/utils/request';

export default {
    // 客户端接口
    getActiveBanners() {
        return axios.get('/banners/client/list');
    },

    // 管理端接口
    getAdminList() {
        return axios.get('/banners/admin/list');
    },
    saveBanner(data) {
        return axios.post('/banners/admin/save', data);
    },
    deleteBanner(id) {
        return axios.delete(`/banners/admin/delete/${id}`);
    }
};
